/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Describes mode for selecting marker type when the series marker type is set to automatic.
 */
export var MarkerAutomaticBehavior = /*@__PURE__*/ (function (MarkerAutomaticBehavior) {
    /**
     * Sets a circle marker on most series and no marker on bar, column, waterfall, polygon, and step series.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["CircleSmart"] = 0] = "CircleSmart";
    /**
     * Sets no visible marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["None"] = 1] = "None";
    /**
     * Sets an marker on most series based on its index and no marker on bar, column, waterfall, polygon, and step series.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["SmartIndexed"] = 2] = "SmartIndexed";
    /**
     * Sets marker for each series in the chart based on its index: circle, triangle, pyramid, etc.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Indexed"] = 3] = "Indexed";
    /**
     * Sets circle marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Circle"] = 4] = "Circle";
    /**
     * Sets flat-top triangle marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Triangle"] = 5] = "Triangle";
    /**
     * Sets flat-base triangle marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Pyramid"] = 6] = "Pyramid";
    /**
     * Sets square marker shape on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Square"] = 7] = "Square";
    /**
     * Sets diamond marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Diamond"] = 8] = "Diamond";
    /**
     * Sets pentagon marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Pentagon"] = 9] = "Pentagon";
    /**
     * Sets Hexagon marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Hexagon"] = 10] = "Hexagon";
    /**
     * Sets four-pointed star marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Tetragram"] = 11] = "Tetragram";
    /**
     * Sets five-pointed star marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Pentagram"] = 12] = "Pentagram";
    /**
     * Sets six-pointed star marker on all series in the chart.
     */
    MarkerAutomaticBehavior[MarkerAutomaticBehavior["Hexagram"] = 13] = "Hexagram";
    return MarkerAutomaticBehavior;
})({});
/**
 * @hidden
 */
export var MarkerAutomaticBehavior_$type = /*@__PURE__*/ markEnum('MarkerAutomaticBehavior', 'CircleSmart,0|None,1|SmartIndexed,2|Indexed,3|Circle,4|Triangle,5|Pyramid,6|Square,7|Diamond,8|Pentagon,9|Hexagon,10|Tetragram,11|Pentagram,12|Hexagram,13');
